import { toPayableAmount } from '@features/rooms/helpers/toPayableAmount.helper';
import { Discount, Price, Rate } from 'shared-types/Common';

export type EntityListItem = Rate & { id?: string };

export const findSelectedEntity = (
  metaEntity: { rates?: EntityListItem[]; rooms?: EntityListItem[] },
  entityId: string
) => {
  const entities = metaEntity.rates || metaEntity.rooms;
  return (
    entities?.find(({ rateId }) => String(entityId) === String(rateId)) ||
    entities?.find(({ id }) => String(entityId) === String(id))
  );
};

export const toPayableStayPrice = (
  entity: { pricePerStay?: Price | null; discount?: Discount | null } | null | undefined
): Price | null =>
  entity?.pricePerStay
    ? { ...entity.pricePerStay, amount: toPayableAmount(entity.pricePerStay, entity.discount) ?? 0 }
    : null;
